import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, map, Observable, throwError } from "rxjs";
import { environment } from "../../../environments/environment";
import { LaborOperationMapper } from "../mappers/labor-operation.mapper";
import { PartComponentMapper } from "../mappers/part-component.mapper";
import { LaborOperation } from "../models/labor-operation";
import { PartComponent } from "../models/part-component";

export interface IReferenceService {
    /**
     * Gets a list of part components.
     * @returns A list of part components.
     * @see PartComponent
     */
    getPartComponents(): Observable<PartComponent[]>;

    /**
     * Gets a list of labor operations.
     * @returns A list of labor operations.
     * @see LaborOperation
     */
    getLaborOperations(): Observable<LaborOperation[]>;
}

@Injectable({
    providedIn: 'root'
})
export class ReferenceService implements IReferenceService {
    public baseContractManagementUrl = environment.baseClaimSubmissionUrl;
    public httpClient: HttpClient;

    constructor(http: HttpClient) {
        this.httpClient = http;
    }

    public getPartComponents(): Observable<PartComponent[]> {
        const url = `${this.baseContractManagementUrl}/reference/components/parts`;

        const httpOptions = {
            headers: new HttpHeaders({
                'Accept': 'application/json',
                'reportProgress': 'true',
                'observe': 'events',
                'timeout': '90000',
            }),
        }

        return this.httpClient.get(url, httpOptions)
            .pipe(
                map(response => {
                    return (response as []).map(PartComponentMapper.mapPartComponent);
                }),
                catchError((error) => {
                    return throwError(() => new Error(error));
                })
            );
    }

    public getLaborOperations(): Observable<LaborOperation[]> {
        const url = `${this.baseContractManagementUrl}/reference/labor-operations`;

        const httpOptions = {
            headers: new HttpHeaders({
                'Accept': 'application/json',
                'reportProgress': 'true',
                'observe': 'events',
                'timeout': '90000',
            }),
        }
        
        return this.httpClient.get(url, httpOptions)
            .pipe(
                map(response => {
                    return (response as []).map(LaborOperationMapper.mapLaborOperation);
                }),
                catchError((error) => {
                    return throwError(() => new Error(error));
                })
            );
    }
}